// extracted by mini-css-extract-plugin
export default {"feedback":"eNnJx","wrapper":"Mc8R3","heading":"ctY08","description":"wz9N3","form":"TA7iy","formWrapper":"X7j3Q","input":"mf5Th","inputText":"jWH1P","button":"cSbjU","info":"B2b4J"};